module.exports = __webpack_public_path__ + "img/mobile-lockup.dc65f8ce.png";